import { render, staticRenderFns } from "./Bagde.vue?vue&type=template&id=fc3a7f8c&scoped=true&"
import script from "./Bagde.vue?vue&type=script&lang=js&"
export * from "./Bagde.vue?vue&type=script&lang=js&"
import style0 from "./Bagde.vue?vue&type=style&index=0&id=fc3a7f8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3a7f8c",
  null
  
)

export default component.exports